import { render, staticRenderFns } from "./szStudios.vue?vue&type=template&id=9014fb44&scoped=true"
import script from "./szStudios.vue?vue&type=script&lang=js"
export * from "./szStudios.vue?vue&type=script&lang=js"
import style0 from "./szStudios.vue?vue&type=style&index=0&id=9014fb44&prod&lang=scss&scoped=true"
import style1 from "./szStudios.vue?vue&type=style&index=1&id=9014fb44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9014fb44",
  null
  
)

export default component.exports